module.exports = __webpack_public_path__ + "pic/51.fe3c96e5.png";